import { createContext } from 'react';

import { Flash } from './Models';

export interface FlashContextProps {
  createFlash: (flash: Omit<Flash, 'created'>, ttl?: number) => void;
}

export default createContext<FlashContextProps>({
  createFlash: () => {
    // nothing
  },
});
